module.exports = __webpack_public_path__ + "static/media/discord-hover.d182b78e.png";